// extracted by mini-css-extract-plugin
module.exports = {"container":"ta","hide":"tb","content":"tc","close":"td","closeIcon":"te","svgStyles":"tf"};